/** Cooldown nach HTTP 429 für OnlyOffice-JWT/Extract — verhindert Request-Stürme bei Re-Init-Schleifen. */

const COOLDOWN_MS = 30_000;
/** Cooldown nach 422/leerem Extract — kein Retry-Sturm bei neuen/leeren Dokumenten. */
const INSUFFICIENT_COOLDOWN_MS = 60_000;

const blockedUntilByKey = new Map<string, number>();
const insufficientUntilByKey = new Map<string, number>();

export function portalOnlyofficeRateLimitKey(scope: 'jwt' | 'extract', docKey: string): string {
  return `${scope}:${docKey}`;
}

export function portalOnlyofficeRateLimitBlocked(key: string): boolean {
  const until = blockedUntilByKey.get(key) ?? 0;
  if (Date.now() >= until) {
    if (until > 0) blockedUntilByKey.delete(key);
    return false;
  }
  return true;
}

export function portalOnlyofficeRateLimitMark429(key: string): void {
  blockedUntilByKey.set(key, Date.now() + COOLDOWN_MS);
}

export function portalOnlyofficeRateLimitRemainingMs(key: string): number {
  const until = blockedUntilByKey.get(key) ?? 0;
  return Math.max(0, until - Date.now());
}

export function portalOnlyofficeRateLimitInsufficientBlocked(key: string): boolean {
  const until = insufficientUntilByKey.get(key) ?? 0;
  if (Date.now() >= until) {
    if (until > 0) insufficientUntilByKey.delete(key);
    return false;
  }
  return true;
}

export function portalOnlyofficeRateLimitMarkInsufficient(key: string): void {
  insufficientUntilByKey.set(key, Date.now() + INSUFFICIENT_COOLDOWN_MS);
}

export function portalOnlyofficeRateLimitClearInsufficient(key: string): void {
  insufficientUntilByKey.delete(key);
}
